import { render, staticRenderFns } from "./confirmReceipt.vue?vue&type=template&id=14862c0e&scoped=true&"
import script from "./confirmReceipt.vue?vue&type=script&lang=js&"
export * from "./confirmReceipt.vue?vue&type=script&lang=js&"
import style0 from "./confirmReceipt.vue?vue&type=style&index=0&id=14862c0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14862c0e",
  null
  
)

component.options.__file = "confirmReceipt.vue"
export default component.exports